import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "app flex flex-col" };
import { onErrorCaptured, ref } from 'vue';
import { OrToastContainerV3, OrNotificationV3 } from '@onereach/ui-components';
import useI18n from './composables/useI18n';
import TranslatableError from './errors/TranslatableError';
import SentryApi from './sentry';
export default /*#__PURE__*/ _defineComponent({
    __name: 'app',
    setup(__props) {
        const { translate } = useI18n();
        const errorText = ref('');
        onErrorCaptured((error) => {
            if (error instanceof TranslatableError) {
                errorText.value = translate(error.translationKey);
                console.warn(error.innerError);
                SentryApi.captureException(error.innerError);
            }
            else {
                errorText.value = translate('errors.commonText');
                console.warn(error);
                SentryApi.captureException(error);
            }
            return false;
        });
        const discardError = () => {
            errorText.value = '';
        };
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (errorText.value)
                    ? (_openBlock(), _createBlock(_unref(OrNotificationV3), {
                        key: 0,
                        class: "error-notification absolute z-[100] w-[calc(100%-(2*theme(spacing.3xl)))] m-3xl",
                        variant: "error",
                        onClose: discardError
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(errorText.value), 1)
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_unref(OrToastContainerV3)),
                    _createVNode(_component_router_view)
                ])
            ], 64));
        };
    }
});
